/*
 * @Author: leventlei
 * @Date: 2024-01-21 14:00:03
 * @LastEditTime: 2024-01-21 14:06:23
 * @LastEditors: leventlei
 * @Description:通用添加按钮
 * @FilePath: /IOT4CMS/src/components/AddButton/index.tsx
 */
import React, { FC } from 'react'

import iconAdd from '@/assets/images/iotScene/icon_add.png'
import { Button } from 'antd'

import ss from './index.less'

interface AddButtonProps {
	title: string
	onClick: () => void
}

const AddButton: FC<AddButtonProps> = ({ title, onClick }) => {
	return (
		<div className={ss.addButton} onClick={onClick}>
			<img src={iconAdd} className="addIcon" alt="" />
			<Button type="link">{title}</Button>
		</div>
	)
}

export default AddButton
